"use client";
import { usePublicT } from "../../public-locale";


import { asset } from "../assets";
const logoDark = asset("Logo_Optrixis_v2_copie_2Optrixis_Local_Logo.svg");
const logoLight = asset("Logo_Optrixis_v2_copie_4Optrixis_Local_Logo.svg");
const favicon = asset("Favicon_OptrixisOptrixis_Mail.svg");

interface LogoProps { dark?: boolean; className?: string; compact?: boolean; }

export default function Logo({ dark = false, className = "", compact = false }: LogoProps) {
  const t = usePublicT();
  if (compact) return <img src={favicon} alt={t("Optrixis")} className={className || "h-8 w-8"} draggable={false} />;
  return <img src={dark ? logoLight : logoDark} alt={t("Optrixis Local")} className={className || "h-8"} draggable={false} style={{ objectFit: "contain", objectPosition: "left center" }} />;
}
